import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import { Link } from 'react-router';

import RaisedButton from 'material-ui/RaisedButton';

import CircularProgress from 'material-ui/CircularProgress';

import styles from 'styles';

import { deleteNameSuggestion } from 'actions/vessels/vessels';

import { renameVessel } from 'actions/vessels/vessels';

import SuggestionNamesList from './SuggestionNamesList';

class SuggestionNames extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };

        this.renameVessel = this.renameVessel.bind(this);

        this.changeSuggestedName = this.changeSuggestedName.bind(this);

        this.cancelSuggestion = this.cancelSuggestion.bind(this);
    }

    renameVessel() {
        const { vessel, refreshVessel } = this.props;

        this.setState(
            {
                loading: true,
            },

            () => this.props.renameVessel({ ...vessel }, refreshVessel),
        );
    }

    changeSuggestedName(sName) {
        const { updateSuggestedName } = this.props;

        updateSuggestedName(sName);
    }

    cancelSuggestion() {
        const {
            vessel: { suggestedName },
            refreshVessel,
        } = this.props;

        if (!suggestedName) return;

        this.props.deleteNameSuggestion({ vessel: this.props.vessel, refreshVessel, suggestedName });
    }

    render() {
        const { vessel } = this.props;

        const { loading } = this.state;

        const showNameSuggestionBlock =
            !!(vessel.nameSuggestion && vessel.suggestedName);

        if (loading && showNameSuggestionBlock) {
            return (
                <div className="col-xs-7 center-xs middle-xs">
                    <CircularProgress />
                </div>
            );
        }

        return (
            showNameSuggestionBlock && (
                <div className="col-xs-7 middle-xs">
                    <div className="row">
                        <SuggestionNamesList
                            suggestedName={vessel.suggestedName}
                            nameSuggestion={vessel.nameSuggestion}
                            changeSuggestedName={this.changeSuggestedName}
                        />
                    </div>

                    <div className="row center-xs bottom-xs">
                        <div className="col-xs-6">
                            <RaisedButton
                                primary
                                label="Save"
                                style={{ margin: '0 20px 0 0' }}
                                onClick={this.renameVessel}
                            />
                        </div>

                        <div className="col-xs-6">
                            <RaisedButton
                                secondary
                                style={styles.autoHeightContainer}
                                overlayStyle={styles.autoHeightButton}
                                onClick={this.cancelSuggestion}
                                label="Cancel"
                                
                            />
                        </div>
                    </div>
                </div>
            )
        );
    }
}

export default connect(null, dispatch =>
    bindActionCreators(
        {
            renameVessel,

            deleteNameSuggestion,
        },

        dispatch,
    ))(SuggestionNames);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/SuggestionNames.jsx